import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\ZoteroController::url
* @see Http/Controllers/ZoteroController.php:47
* @route '/integrations/zotero/auth/url'
*/
export const url = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: url.url(options),
    method: 'get',
})

url.definition = {
    methods: ["get","head"],
    url: '/integrations/zotero/auth/url',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ZoteroController::url
* @see Http/Controllers/ZoteroController.php:47
* @route '/integrations/zotero/auth/url'
*/
url.url = (options?: RouteQueryOptions) => {
    return url.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ZoteroController::url
* @see Http/Controllers/ZoteroController.php:47
* @route '/integrations/zotero/auth/url'
*/
url.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: url.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ZoteroController::url
* @see Http/Controllers/ZoteroController.php:47
* @route '/integrations/zotero/auth/url'
*/
url.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: url.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ZoteroController::url
* @see Http/Controllers/ZoteroController.php:47
* @route '/integrations/zotero/auth/url'
*/
const urlForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: url.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ZoteroController::url
* @see Http/Controllers/ZoteroController.php:47
* @route '/integrations/zotero/auth/url'
*/
urlForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: url.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ZoteroController::url
* @see Http/Controllers/ZoteroController.php:47
* @route '/integrations/zotero/auth/url'
*/
urlForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: url.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

url.form = urlForm

/**
* @see \App\Http\Controllers\ZoteroController::callback
* @see Http/Controllers/ZoteroController.php:75
* @route '/integrations/zotero/auth/callback'
*/
export const callback = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: callback.url(options),
    method: 'get',
})

callback.definition = {
    methods: ["get","head"],
    url: '/integrations/zotero/auth/callback',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ZoteroController::callback
* @see Http/Controllers/ZoteroController.php:75
* @route '/integrations/zotero/auth/callback'
*/
callback.url = (options?: RouteQueryOptions) => {
    return callback.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ZoteroController::callback
* @see Http/Controllers/ZoteroController.php:75
* @route '/integrations/zotero/auth/callback'
*/
callback.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: callback.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ZoteroController::callback
* @see Http/Controllers/ZoteroController.php:75
* @route '/integrations/zotero/auth/callback'
*/
callback.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: callback.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ZoteroController::callback
* @see Http/Controllers/ZoteroController.php:75
* @route '/integrations/zotero/auth/callback'
*/
const callbackForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: callback.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ZoteroController::callback
* @see Http/Controllers/ZoteroController.php:75
* @route '/integrations/zotero/auth/callback'
*/
callbackForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: callback.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ZoteroController::callback
* @see Http/Controllers/ZoteroController.php:75
* @route '/integrations/zotero/auth/callback'
*/
callbackForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: callback.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

callback.form = callbackForm

const auth = {
    url: Object.assign(url, url),
    callback: Object.assign(callback, callback),
}

export default auth